export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "js/worker.72a75a40.worker.js");
}
